import { post } from 'data/services/apiService';
import { API_URL } from 'data/services/apiConstants';

export const REQUEST_DOCUMENT_REQUEST = 'REQUEST_DOCUMENT_REQUEST';
export const REQUEST_DOCUMENT_SUCCESS = 'REQUEST_DOCUMENT_SUCCESS';
export const REQUEST_DOCUMENT_ERROR = 'REQUEST_DOCUMENT_ERROR';
export const CLEAR_DOCUMENT_REQUEST_ERROR = 'CLEAR_DOCUMENT_REQUEST_ERROR';

const initialState = {
	isSubmitting: false,
	hasError: false,
};

// `post` resolves with the API's JSON body and re-throws failures (VWA-2555), but the
// callers of these thunks (CheckoutPage, DocumentRequestModal, HistoricDocumentRequestModal)
// branch on the returned action's `type`. Resolve to the dispatched success/error action
// so a successful request is reported as one, and a failure never becomes an unhandled
// rejection.
// authToken is the logged-in user's, so the backend saves the request against the account and fills
// in a name or phone left empty; null for a visitor who is not logged in.
const postDocumentRequest = (dispatch, url, data, authToken = null) => {
	dispatch(requestDocumentRequest());
	return post({ dispatch, url, data, authToken })
		.then((result) => dispatch(requestDocumentSuccess(result)))
		.catch((error) => dispatch(requestDocumenError(error)));
};

export const historicDocumentRequest = ({ email, name, phone, address, description }) => (dispatch, getState) => {
	let url = `${API_URL}/api/historic-document-requests`;

	let data = {
		propertyAddress: address,
		description: description,
		email: email,
	};

	if (name) {
		data.name = name;
	}
	if (phone) {
		data.phone = phone;
	}

	return postDocumentRequest(dispatch, url, data);
};

export const requestDocumentByEmail = ({ propertyId, documentName, email, name, phone, extra, dataSet, itemNumber }) => (dispatch, getState) => {
	let url = `${API_URL}/api/property/${propertyId}/document-request`;
	let data = {
		document: documentName,
		email: email,
	};

	if (name) {
		data.name = name;
	}
	if (phone) {
		data.phone = phone;
	}
	if (extra) {
		data.extra = extra;
	}
	// The table and record a Resolve or Request button was clicked on, for the n8n webhook (VWA-2910)
	if (dataSet) {
		data.dataset = dataSet;
	}
	if (itemNumber) {
		data.item_number = itemNumber;
	}

	return postDocumentRequest(dispatch, url, data, getState().user.authToken);
};

// items are cart items. Each goes as its own entry so it keeps its details (e.g. its job
// number); `documents` repeats the names for a backend deployed before VWA-2910.
export const bulkDocumentRequest = ({ propertyId, items, email, name, phone, extra }) => (dispatch, getState) => {
	let url = `${API_URL}/api/property/${propertyId}/bulk-document-request`;
	let data = {
		items: items.map((item) => ({
			document: item.documentName,
			extra: item.extra || null,
			dataset: item.dataSet || null,
			item_number: item.itemNumber || null,
		})),
		documents: items.map((item) => item.documentName),
		email: email,
	};

	if (name) {
		data.name = name;
	}
	if (phone) {
		data.phone = phone;
	}
	if (extra) {
		data.extra = extra;
	}

	return postDocumentRequest(dispatch, url, data, getState().user.authToken);
};

export const requestDocumentByUserId = (propertyId, documentName, userId) => (dispatch, getState) => {
	let state = getState();
	let url = `${API_URL}/api/property/${propertyId}/document-request`;
	dispatch(requestDocumentRequest());
	return post({
		dispatch,
		url,
		authToken: state.user.authToken,
		data: {
			document: documentName,
			user: {
				id: userId,
			},
		},
		onSuccess: (result) => {
			dispatch(requestDocumentSuccess(result))
		},
		onError: error => dispatch(requestDocumenError(error)),
	});
};

export const clearDocumentRequestError = () => ({
	type: CLEAR_DOCUMENT_REQUEST_ERROR,
	payload: {
		isSubmitting: false,
		hasError: false,
	}
});

export const requestDocumentRequest = () => ({
	type: REQUEST_DOCUMENT_REQUEST,
	payload: {
		isSubmitting: true,
	}
});

export const requestDocumentSuccess = (data) => ({
	type: REQUEST_DOCUMENT_SUCCESS,
	payload: {
		isSubmitting: false,
		hasError: false,
	}
});

// `error` rides on the action (not the payload merged into state) so callers such as
// CheckoutPage can show the API's message.
export const requestDocumenError = (error) => ({
	type: REQUEST_DOCUMENT_ERROR,
	error,
	payload: {
		isSubmitting: false,
		hasError: true,
	}
});

const docuemntRequestReducer = (state = initialState, action) => {
	switch (action.type) {
		case REQUEST_DOCUMENT_REQUEST:
		case REQUEST_DOCUMENT_SUCCESS:
		case REQUEST_DOCUMENT_ERROR:
		case CLEAR_DOCUMENT_REQUEST_ERROR:
			return {
				...state,
				...action.payload,
			};
		default:
			return state;
	}
};

export default docuemntRequestReducer;
